import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {IResponseGetUsageCurrent} from '@/types';
import {
  ExportExcelUsageDTO,
  GetListUsageCurentDTO,
  GetListUsageDTO,
  HttpService,
  ResponseDTO,
} from '@/shared';
import {ExportPdfUsageDTO} from '@/shared/dto/usage.dto';

@Service()
export class UsageService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async getListUsageList(
    getListUsageDTO: GetListUsageDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getListUsageDTO);
  }

  public async getListUsageCurentDTO(
    getListUsageCurentDTO: GetListUsageCurentDTO,
  ): Promise<ResponseDTO<IResponseGetUsageCurrent>> {
    return this.httpService.request(getListUsageCurentDTO);
  }
  public async exportExcelUsage(
    exportExcelUsageDTO: ExportExcelUsageDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(exportExcelUsageDTO);
  }
  public async exportPDFUsage(
    exportPDFUsageDTO: ExportPdfUsageDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(exportPDFUsageDTO);
  }
}
